import React, { useState } from "react";
import { MyContext } from "./Context";

function ContextContainer({ children }) {
  // const [companyLoginData, setCompanyLoginData] = useState({});
  // const [isAdminLogin, setIsAdminLogin] = useState(false);
  // const [isFreelancerLogin, setIsFreelancerLogin] = useState(false);
  // const [isTitleFilter, setIsTitleFilter] = useState(false);
  // const [inputValue, setInputValue] = useState([]);
  // const [freelancerLoginData, setFreelancerLoginData] = useState({});
  // const [freelancerFind, setFreelancerFind] = useState({});
  // const [oneCompanyJob, setOneCompanyJob] = useState({});
  // const [jobAccepted, setJobAccepted] = useState({});
  const [basketItem, setBasketItem] = useState({});
  // const navigate = useNavigate();

  return (
    <MyContext.Provider
      value={
        {
          basketItem,
          setBasketItem,
          // isAdminLogin,
          // setIsAdminLogin,
          // isFreelancerLogin,
          // setIsFreelancerLogin,
          // isTitleFilter,
          // setIsTitleFilter,
          // inputValue,
          // setInputValue,
          // setFreelancerLoginData,
          // freelancerLoginData,
          // freelancerFind,
          // setFreelancerFind,
          // oneCompanyJob,
          // setOneCompanyJob,
          // jobAccepted,
          // setJobAccepted,
        }
      }
    >
      {children}
    </MyContext.Provider>
  );
}

export default ContextContainer;
